import { HistoryState } from '../../../models';
import { HISTORY_MUTATIONS_KEYS } from '../history.const';
import { HistoryMutation } from '../history.interfaces';

export class SetEnabledQueryHistoryMutation implements HistoryMutation {
  mutations = {
    [HISTORY_MUTATIONS_KEYS.setEnabledQueryHistory]: (localState: HistoryState, enabled: boolean) => {
      localState.queryHistoryEnabled = enabled;
    }
  };
}
